import React, { useState } from "react";
import Icon from "../Icon/Icon";

type NumpadProps = {
  onChange?: (value: string) => void;
  onRemove?: () => void;
};

export const Numpad: React.FC<NumpadProps> = ({ onChange, onRemove }) => {
  const [value, setValue] = useState("");

  const addDigit = (digit: string) => {
    const newValue = value + digit;
    setValue(newValue);
    onChange?.(newValue);
  };

  const removeLastDigit = () => {
    const newValue = value.slice(0, -1);
    setValue(newValue);
    onChange?.(newValue);
  };

  return (
    <div className="grid w-[240px] grid-cols-[repeat(3,1fr)] gap-3">
      {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
        <button
          key={n}
          className="flex h-16 cursor-pointer items-center justify-center rounded-[10px] border-none bg-primary text-[20px] text-white active:scale-95"
          onClick={() => addDigit(n.toString())}
        >
          {n}
        </button>
      ))}

      <button className="flex h-16 cursor-pointer items-center justify-center rounded-[10px] border-none bg-primary text-[20px] text-white active:scale-95"></button>
      <button
        className="flex h-16 cursor-pointer items-center justify-center rounded-[10px] border-none bg-primary text-[20px] text-white active:scale-95"
        onClick={() => addDigit("0")}
      >
        0
      </button>
      <button
        className="flex h-16 cursor-pointer items-center justify-center rounded-[10px] border-none bg-primary text-[20px] text-white active:scale-95"
        onClick={removeLastDigit}
      >
        <Icon className="h-12 w-12 fill-white" variants="deleteLeft" />
      </button>
    </div>
  );
};
